/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterOneLoggedinLogResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class LoggedinLogs<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description List loggedin_logs
   *
   * @tags loggedin_logs
   * @name GetPrivateLoggedinLogs
   * @summary List the loggedin_logs
   * @request GET:/private/loggedin_logs
   */
  getPrivateLoggedinLogs = (
    query?: {
      "filter[created_at]"?: string[];
      /** @min 1 */
      "filter[user]"?: number;
      sort?: string[];
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneLoggedinLogResponse[];
      },
      PresenterError
    >({
      path: `/private/loggedin_logs`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
